
const initNewsSlideshow = () => {
    function updateSlideshowHeight() {
        const slideshows = document.querySelectorAll(".news-list-card-carousel__large");
        if (slideshows.length < 1) return;

        slideshows.forEach(slideshow => {
            const slides = slideshow.querySelectorAll(".uk-slideshow-items .new-card");
            if (slides.length === 0) return;
        
            const isMobile = window.innerWidth < 546;
            const slideHeights = [];
        
            if(!isMobile) {
                const slideshowItems = slideshow.querySelector(".uk-slideshow-items");
                slideshowItems.style.height = `unset`;
            }
        
            slides.forEach(slide => {
            const content = slide.querySelector(".new-card__wrapper--content");
            if (!content) return;
        
            slide.style.setProperty('display', 'grid', 'important');
            const minHeight = isMobile ? 200 : 350;
            slideHeights.push(content.scrollHeight);
            const filteredHeights = slideHeights.filter(height => height > minHeight);
            
            const contentHeight = filteredHeights.length ? Math.max(...filteredHeights) : 0;
        
            if(contentHeight > minHeight && !isMobile) {
                const slideshowItems = slideshow.querySelector(".uk-slideshow-items");
        
                const imageHeight = isMobile ? 250 : 0;
                const controlButtonsHeight = isMobile ? 48 : 0;
        
                if (slideshowItems) {
                    slideshowItems.style.height = `${contentHeight + imageHeight + controlButtonsHeight}px`;
                }
            }
        
            slide.removeAttribute('style')
            });
        })
    }

    window.addEventListener("load", updateSlideshowHeight);
    window.addEventListener("resize", () => {
        clearTimeout(window.resizingTimer);
        window.resizingTimer = setTimeout(updateSlideshowHeight, 250);
    });
}

export default initNewsSlideshow;